// All live tariff amounts are customer-facing, VAT-inclusive ILS.
export const VAT_RATE = 0.18;
export const EMBO_DEV_FEE = 240;
export const EMBO_UNIT_FEE = 12;
export const DELIVERY_PER_50_UNITS = 60;

export const roundMoney = (value) => Math.round((Number(value) + Number.EPSILON) * 100) / 100;

// Extract tax from the payable gross amount, including any discounts. Do not add
// VAT to the customer-facing tariff a second time.
export function extractVatFromGross(grossAmount) {
  const gross = roundMoney(grossAmount);
  const net = roundMoney(gross / (1 + VAT_RATE));
  return { net, vat: roundMoney(gross - net) };
}
